import { inject, Injectable } from '@angular/core';
import { SYSTEM_PARAMS_DATA_SOURCE } from '@core/api/system-params-data-source';
import { BaseGridService } from 'ngx-mt-ui-lib/services/base-grid';
import { Filters, IGridSorting } from 'ngx-mt-ui-lib/interfaces';
import { GRID_ID } from '@app/app.enums';
import { ISystemParamsGridItem } from '@app/core/interfaces/system-params';
import { ECriteria } from 'ngx-mt-ui-lib/enums';

export type TSystemParamsGridFilters = {
  name?: Filters.TFilterModel<'name', string>;
};

@Injectable()
export class SystemParamsGridService extends BaseGridService<
  ISystemParamsGridItem,
  TSystemParamsGridFilters
> {
  private readonly source = inject(SYSTEM_PARAMS_DATA_SOURCE).source;
  public readonly gridId =
    this.source === 'notifications'
      ? GRID_ID['ADMIN.INFORMING.SETTINGS']
      : GRID_ID['ADMIN.SYSTEM_PARAMS'];

  protected override readonly defaultFilters: TSystemParamsGridFilters =
    this.source === 'notifications'
      ? {}
      : {
          name: {
            field: 'name',
            criteria: ECriteria.like,
            value: null,
          },
        };

  protected override readonly defaultSorting: IGridSorting[] = [
    {
      field: 'name',
      direction: 'asc',
      index: 0,
    },
  ];

  constructor() {
    super();
    this.init();
  }
}
